import { render, staticRenderFns } from "./AdminOrdersOld.vue?vue&type=template&id=01cb0228&scoped=true"
import script from "./AdminOrdersOld.vue?vue&type=script&lang=js"
export * from "./AdminOrdersOld.vue?vue&type=script&lang=js"
import style0 from "./AdminOrdersOld.vue?vue&type=style&index=0&id=01cb0228&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cb0228",
  null
  
)

export default component.exports